export type CheckboxState = 'checked' | 'unchecked' | 'indeterminate'

export const getCheckboxStateProps = (checkboxState: CheckboxState) => {
  switch (checkboxState) {
    case 'checked':
      return {
        indeterminate: false,
        checked: true,
      }
    case 'indeterminate':
      return {
        indeterminate: true,
        checked: false,
      }
    default:
      return {
        indeterminate: false,
        checked: false,
      }
  }
}
